import { Popover } from "antd";
import React, { useState } from "react";
import { FiEdit3 } from "@react-icons/all-files/fi/FiEdit3";
import { useDispatch } from "react-redux";
import {
    updateMobilyticsJob,
    updatePolygonName,
} from "../../../../Actions/Actions";
import { IGCPBigQueryJob } from "../../../../Models/Models";
import {
    firstLetterCapitalizer,
    ReportH4,
    PolygonNameWithCircle,
} from "../../../Common";
import EditInput from "../../../Common/EditInput";
import styled from "styled-components";

interface GPSHeaderDateBlockProps {
  job: IGCPBigQueryJob;
  jobIndex: number;
  isSharing: boolean;
}

const GPSHeaderDateBlockP = styled.p`
  line-height: normal;
`;

export const GPSHeaderDateBlock = (props: GPSHeaderDateBlockProps) => {
    const [editing, setEditing] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [newName, setNewName] = useState<string>(props.job.jobPolygon.name);

    const dispatch = useDispatch();

    const { job } = props;
    const fromDateObj = new Date(job.queryFromDateTime);
    const toDateObj = new Date(job.queryToDateTime);

    const lowercase = job.milesLessOrGreater.toLowerCase();
    const initCap = lowercase.charAt(0).toUpperCase() + lowercase.slice(1);
    const miles = job.miles === 1 ? "mile" : "miles";
    const distanceFilterText
    = job.milesLessOrGreater === "GREATER" && job.miles === 0
        ? "Household Distance Filter: None"
        : `Includes Households ${initCap} than ${job.miles} ${miles}`;

    const dateFormatter = (date: Date): string => {
        return `${
            Number(date.getMonth()) + 1
        }/${date.getDate()}/${date.getFullYear()}`;
    };

    const timeFormatter = (date: Date): string => {
        return `${date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
        })}`;
    };

    const dateTimeFormatter = (startDate: Date, endDate: Date): string => {
        return `${dateFormatter(startDate)} - ${dateFormatter(
            endDate
        )} ${timeFormatter(startDate)} - ${timeFormatter(endDate)}`;
    };

    const onEditClick = () => {
        setEditing(true);
    };

    const onNewNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewName(event.target.value);
    };

    const onCancelEditClick = () => {
        setNewName(props.job.jobPolygon.name);
        setEditing(false);
    };

    const onSubmit = () => {
        setLoading(true);
        updatePolygonName(props.job.jobId, newName).then((newJob) => {
            // Refresh left nav to get new polygon name
            if((window as any).scout) {
                (window as any).scout.interop.api.refreshMobilyticsVisitorsList();
            }
            dispatch(updateMobilyticsJob(newJob));
            setEditing(false);
            setLoading(false);
        });
    };

    const place = props.job?.mobilyticsPlace;
    if (place) {
        place.address = firstLetterCapitalizer(place.address);
        place.city = firstLetterCapitalizer(place.city);
    }

    const standardNameDisplay = (
        <>
            {job.jobPolygon.name}
            {!props.isSharing && (
                <Popover content="Edit scenario name">
                    <FiEdit3
                        onClick={onEditClick}
                        style={{
                            position: "relative",
                            top: "2px",
                            marginLeft: "4px",
                            cursor: "pointer",
                        }}
                    />
                </Popover>
            )}
        </>
    );

    return (
        <div>
            <PolygonNameWithCircle
                circleColor={props.jobIndex === 0 ? "lightGreen" : "darkGreen"}
                circleWidth={12}
                circleHeight={12}
                children={
                    <ReportH4 style={{ fontSize: "13px", marginBottom: 0 }}>
                        {editing ? (
                            <EditInput
                                isLoading={loading}
                                name={newName}
                                onCancel={onCancelEditClick}
                                onChange={onNewNameChange}
                                onSubmit={onSubmit}
                            />
                        ) : (
                            standardNameDisplay
                        )}
                    </ReportH4>
                }
            />
            {place && (
                <GPSHeaderDateBlockP
                    style={{
                        marginBottom: 0,
                    }}
                >
                    {`${place.address}, ${place.city} ${place.state} ${place.zipcode}`}
                </GPSHeaderDateBlockP>
            )}
            <GPSHeaderDateBlockP>
                {dateTimeFormatter(fromDateObj, toDateObj)}
                <br />
                {distanceFilterText}
            </GPSHeaderDateBlockP>
        </div>
    );
};
